import { PropsWithChildren, ReactNode } from 'react';
import { styled } from 'styled-components';

import { Spacer } from '../../common/components/Spacer';

export const LinkPageBackground = styled.div`
  margin: -19px -21px; // Main 상쇄
  width: 100%;
  padding: 19px 21px; // Main 상쇄
  background-color: white;
  ${p => p.theme.isMobile && 'display: contents;'}
`;

export const LinkPageContainer = styled.div`
  text-align: center;
  padding: ${p => (p.theme.isMobile ? '0px' : '80px')} 21px
    ${p => (p.theme.isMobile ? '30px' : '60px')};
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 60px;
  background: var(--HPACS_BG_grey, #f5f5f5);
`;

export const MessageTitle = styled.div`
  font-size: 24px;
  color: ${p => p.theme.colors.primary};
`;

export const MessageContent = styled.div``;

interface MessageComponentProps extends PropsWithChildren {
  icon: ReactNode;
  title: string;
}
export const MessageComponent = ({
  icon,
  title,
  children,
}: MessageComponentProps) => {
  return (
    <>
      <IconWrapper>{icon}</IconWrapper>
      <Spacer height={30} />
      <MessageTitle>{title}</MessageTitle>
      <Spacer height={20} />
      {children}
    </>
  );
};
